/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _6 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>6 - Селект</h2>
    <p className={styles.description}>
      Все просто - есть селект, есть опции, у селекта есть <code className={styles.code}>value</code> и{' '}
      <code className={styles.code}>onChange</code>.{' '}
    </p>
    <p className={styles.description}>Добавляем выбор возрастной категории. </p>
    <CopyBlock
      text={`const INITIAL_STATE = {
  login: '',
  email: '',
  password: '',
  agreed: false,
  gender: null,
  age: '',
};

class SignUpForm extends React.Component {
  state = {
    ...INITIAL_STATE,
  };

  /* ... */

  render() {
    const { login, email, password, agreed, gender, age } = this.state;

    return (
      <form onSubmit={this.handleSubmit}>
        {/* ... */}

        <label>
          Choose your age
          <select name="age" value={age} onChange={this.handleChange}>
            <option value="" disabled>
              ...
            </option>
            <option value="18-25">18-25</option>
            <option value="26-35">26-35</option>
            <option value="36+">36+</option>
          </select>
        </label>

        <button type="submit" disabled={!agreed}>
          Sign up as {login}
        </button>
      </form>
    );
  }
}`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
  </section>
))
